var _path, _path2, _path3, _path4, _path5, _path6, _path7, _filter;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicrosoftPowerpoint = function SvgMicrosoftPowerpoint(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M27 96.667V31.333C27 19.083 31.111 15 43.444 15h24.667L101 47.667v49C101 108.917 96.889 113 84.555 113h-41.11C31.11 113 27 108.917 27 96.667",
    style: {
      fill: "#000",
      fillOpacity: 0.08
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg_icon_MicrosoftPowerpoint__filter0_dd_2256_17070)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16",
    style: _defineProperty(_defineProperty({
      fill: "#fefefe"
    }, "fill", "color(display-p3 .9961 .9961 .9961)"), "fillOpacity", 1)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftPowerpoint__paint0_linear_2256_17070)",
    fillOpacity: 0.16,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftPowerpoint__paint1_linear_2256_17070)",
    fillOpacity: 0.08,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftPowerpoint__paint2_radial_2256_17070)",
    fillOpacity: 0.2,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftPowerpoint__paint3_radial_2256_17070)",
    fillOpacity: 0.4,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftPowerpoint__paint4_radial_2256_17070)",
    fillOpacity: 0.8,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    d: "M68.186 81.465 65.396 61h-.209c-10.148.03-18.367 8.249-18.396 18.396v.209z",
    style: _defineProperty(_defineProperty({
      fill: "#ed6c47"
    }, "fill", "color(display-p3 .9294 .4235 .2784)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F6B",
    d: "M65.604 61h-.209v18.605l9.303 3.72L84 79.606v-.209C83.97 69.25 75.751 61.03 65.604 61",
    style: _defineProperty(_defineProperty({
      fill: "#ff8f6b"
    }, "fill", "color(display-p3 1 .5608 .4196)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D35230",
    d: "M84 79.605v.204c-.03 10.15-8.25 18.371-18.4 18.4h-.41c-10.15-.029-18.37-8.25-18.4-18.4v-.204z",
    style: _defineProperty(_defineProperty({
      fill: "#d35230"
    }, "fill", "color(display-p3 .8275 .3216 .1882)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M66.326 70.144v19.851a1.713 1.713 0 0 1-1.703 1.703H51.181c-.26-.298-.511-.614-.744-.93a18.25 18.25 0 0 1-3.646-10.959V79.4a18.2 18.2 0 0 1 2.995-10.028c.205-.316.419-.632.651-.93h14.186a1.715 1.715 0 0 1 1.703 1.702",
    opacity: 0.1,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.395 71.074v19.852a1.713 1.713 0 0 1-1.702 1.702H52.028q-.441-.45-.847-.93c-.26-.298-.511-.614-.744-.93a18.25 18.25 0 0 1-3.646-10.959V79.4a18.2 18.2 0 0 1 2.995-10.028h13.907a1.715 1.715 0 0 1 1.702 1.702",
    opacity: 0.2,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.395 71.074v17.991a1.715 1.715 0 0 1-1.702 1.702H50.437a18.25 18.25 0 0 1-3.646-10.958V79.4a18.2 18.2 0 0 1 2.995-10.028h13.907a1.715 1.715 0 0 1 1.702 1.702",
    opacity: 0.2,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.465 71.074v17.991a1.715 1.715 0 0 1-1.702 1.702H50.437a18.25 18.25 0 0 1-3.646-10.958V79.4a18.2 18.2 0 0 1 2.995-10.028h12.977a1.715 1.715 0 0 1 1.702 1.702",
    opacity: 0.2,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftPowerpoint__paint5_linear_2256_17070)",
    d: "M45.705 69.372H62.76c.942 0 1.705.763 1.705 1.705v17.055c0 .942-.763 1.705-1.705 1.705H45.705A1.705 1.705 0 0 1 44 88.132V71.077c0-.942.763-1.705 1.705-1.705"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.419 73.92a4.7 4.7 0 0 1 3.105.91 3.26 3.26 0 0 1 1.08 2.635 3.67 3.67 0 0 1-.532 1.97 3.56 3.56 0 0 1-1.514 1.337 5.14 5.14 0 0 1-2.276.478h-2.157v4.01h-2.21V73.92zm-2.296 5.598h1.901c.603.044 1.201-.134 1.681-.501a1.86 1.86 0 0 0 .569-1.467q0-1.875-2.18-1.875h-1.971z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z",
    style: _defineProperty(_defineProperty({
      fill: "#fefefe"
    }, "fill", "color(display-p3 .9948 .9948 .9948)"), "fillOpacity", 1)
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftPowerpoint__paint6_linear_2256_17070)",
    fillOpacity: 0.12,
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.08,
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z",
    style: {
      fill: "#fff",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_MicrosoftPowerpoint__paint0_linear_2256_17070",
    x1: 64,
    x2: 64,
    y1: 16,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_MicrosoftPowerpoint__paint1_linear_2256_17070",
    x1: 64,
    x2: 64,
    y1: 16,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_MicrosoftPowerpoint__paint5_linear_2256_17070",
    x1: 47.555,
    x2: 60.91,
    y1: 68.04,
    y2: 91.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4C28",
    style: _defineProperty(_defineProperty({
      stopColor: "#ca4c28"
    }, "stopColor", "color(display-p3 .7922 .298 .1569)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C5401E",
    style: _defineProperty(_defineProperty({
      stopColor: "#c5401e"
    }, "stopColor", "color(display-p3 .7725 .251 .1176)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62F14",
    style: _defineProperty(_defineProperty({
      stopColor: "#b62f14"
    }, "stopColor", "color(display-p3 .7137 .1843 .0784)"), "stopOpacity", 1)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_MicrosoftPowerpoint__paint6_linear_2256_17070",
    x1: 84,
    x2: 71.5,
    y1: 31,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_MicrosoftPowerpoint__paint2_radial_2256_17070",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 34 -29.1429 0 85.5 34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_MicrosoftPowerpoint__paint3_radial_2256_17070",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.00012 20.49993 -23.02097 -10.10694 87.5 33.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_MicrosoftPowerpoint__paint4_radial_2256_17070",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135 38.494 32.933)scale(27.5772 18.3848)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "svg_icon_MicrosoftPowerpoint__filter0_dd_2256_17070",
    width: 88,
    height: 112,
    x: 20,
    y: 16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2256_17070"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2256_17070",
    result: "effect2_dropShadow_2256_17070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2256_17070",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftPowerpoint);
export { ForwardRef as ReactComponent };